import React from 'react';
import clsx from 'clsx';
import { AccentToken } from '../../theme/accents';

interface CardShellProps {
  /** Kept for API compatibility; the card chrome is now neutral (identity
   *  lives in the list-row type badge), so the accent no longer tints it. */
  accent?: AccentToken;
  className?: string;
  children: React.ReactNode;
}

/**
 * The outer container shared by every entity card: rounded corners, a single
 * 1px border, a soft even shadow, and a full-height flex column so footers
 * align across a grid row.
 */
const CardShell: React.FC<CardShellProps> = ({
  className,
  children,
}) => {
  return (
    <div
      className={clsx(
        // Clean, uniform card: 12px radius (matches Semi's large radius), a
        // single 1px border, and a soft *even* shadow — not the old top-heavy
        // shadow-sm + 2px colored top edge, which made the top of each card
        // look weighted. Entity identity now lives in the list-row type badge,
        // so the card itself stays neutral and premium.
        'refined-card group h-full flex flex-col',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default CardShell;
